module.exports = __webpack_public_path__ + "img/img15.31e2687a.jpg";